import { LangEum } from "@/constant";

// 界面图片资源
export const imgResource = {
    // 719B
    ['back-icon']: 'https://cdn.poizon.com/node-common/6d01c815fffacd295a1a73be82d2d8ab.png',
    // 4.9kb
    ['share-icon']: 'https://cdn.poizon.com/node-common/5a422220170d2c8fcd5367c3614a4ffe.png',
    // 8.7kb
    // todo: 这个图片过大
    ['footer-back']: 'https://cdn.poizon.com/node-common/1c8a64fdba6d3b061da564dd5db45931.png',
    // 2.8kb
    ['aleady-get-coupone']: {
        zh: 'https://cdn.poizon.com/node-common/0178b1f79da23cfd7357f2eb45a406f8.png',
        [LangEum['zh-SG']]: 'https://cdn.poizon.com/node-common/0178b1f79da23cfd7357f2eb45a406f8.png',
        [LangEum['zh-MY']]: 'https://cdn.poizon.com/node-common/0178b1f79da23cfd7357f2eb45a406f8.png',
        'zh-TW': 'https://cdn.poizon.com/node-common/0178b1f79da23cfd7357f2eb45a406f8.png',
        [LangEum['zh-MO']]: 'https://cdn.poizon.com/node-common/0178b1f79da23cfd7357f2eb45a406f8.png',
        [LangEum['zh-TW2']]: 'https://cdn.poizon.com/node-common/0178b1f79da23cfd7357f2eb45a406f8.png',
        en: 'https://cdn.poizon.com/node-common/3f98f850cdfeadc25e0823a1eddd8460.png',
        ja: 'https://cdn.poizon.com/node-common/d341a7b10a2a9f6749c409b944d8a93e.png',
    }
    
};
